import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { AdminLandlord } from '@root/types';
import api from '@shared/api';
import routes from '@root/routes';
import Container from '@components/shared/Admin/Container';
import Form from '../Form';

const EditPage = () => {
  const { t } = useTranslation('admin');
  const { id } = useParams<{ id: string }>();
  const [landlord, setLandlord] = useState<AdminLandlord | null>(null);

  const fetchLandlord = async () => {
    const response = await api.fetch(routes.api.admin.landlord(id));
    setLandlord(await response.json());
  };

  useEffect(() => {
    fetchLandlord();
  }, [id]);

  const onSubmitSuccess = () => {
    notification.success({ message: t('landlord.updateSuccess', { name: landlord!.companyName }) });
    fetchLandlord();
  };

  const onSaveSuccess = ({ message }: { message?: string } = {}) => {
    if (message) notification.success({ message });
    fetchLandlord();
  };

  return landlord ? (
    <Container title={t('landlord.editTitle', { name: landlord.companyName })}>
      <Form
        fetchLandlord={fetchLandlord}
        landlord={landlord}
        submitText={t('common.updateButton')}
        onSubmitSuccess={onSubmitSuccess}
        onSaveSuccess={onSaveSuccess}
      />
    </Container>
  ) : null;
};

export default EditPage;
